var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.buttons[_vm.variation], _vm.buttons[_vm.size]],attrs:{"disabled":_vm.disabled},on:{"click":function () { return _vm.$emit('click'); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }